<script setup lang="ts">
import { ref, computed } from 'vue';
import { UiDetailTabs, UiDetailTabsItem } from '@shopexperts/shared';
import ExpertReviewsList from './ExpertReviewsList.vue';

defineProps<{
  expertId: number;
}>();

const activeTab = ref<'pending' | 'published' | 'imported'>('pending');

const pendingListRef = ref<InstanceType<typeof ExpertReviewsList> | null>(null);
const publishedListRef = ref<InstanceType<typeof ExpertReviewsList> | null>(null);

const pendingCount = computed(() => {
  return pendingListRef.value?.stats?.total_pending;
});

const publishedCount = computed(() => {
  return publishedListRef.value?.stats?.total_published;
});
</script>

<template>
  <UiDetailTabs v-model="activeTab" defaultValue="pending" :pad-content="false">
    <UiDetailTabsItem value="pending" label="Pending" :count="pendingCount">
      <div class="pt-4">
        <ExpertReviewsList
          ref="pendingListRef"
          :expert-id="expertId"
          status="pending"
          empty-title="No pending reviews"
          empty-description="This expert has no reviews waiting for moderation."
        />
      </div>
    </UiDetailTabsItem>

    <UiDetailTabsItem value="published" label="Published" :count="publishedCount">
      <div class="pt-4">
        <ExpertReviewsList
          ref="publishedListRef"
          :expert-id="expertId"
          status="published"
          empty-title="No published reviews"
          empty-description="This expert has no published reviews yet."
        />
      </div>
    </UiDetailTabsItem>

    <UiDetailTabsItem value="imported" label="Imported">
      <div class="pt-4">
        <ExpertReviewsList
          :expert-id="expertId"
          source="imported"
          empty-title="No imported reviews"
          empty-description="No reviews have been imported for this expert yet."
        />
      </div>
    </UiDetailTabsItem>
  </UiDetailTabs>
</template>
